module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_7-bdf2fdbe016ba73f67d49e6c2d7f6400.jpg";